import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { IoArrowBackSharp } from "react-icons/io5";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import {
  applyClassToCharacters,
  convertToDateString,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { ApiMemberTypeRequest } from "./ApiMemberTypeRequest";
import swal from "sweetalert";
import { addMember } from "../ApiMember";

const colors = {
  primary: "#1d9fad", // New primary color (teal-cyan)
  text: "#2D3747", // Dark blue-gray
};

const MemberTypeRequestTawajahTalab = ({ history, memberTypeData }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [values, setValues] = useState({});
  const [lastMemberContactWithUnit, setLastMemberContactWithUnit] =
    useState(null);
  const [lastContactWithMemberByUnit, setLastContactWithMemberByUnit] =
    useState(null);

  useEffect(() => {
    setLoading(true);
    setButtonDisable(true);
    ApiMemberTypeRequest()
      .GetMemberAsTawajahTalabFormData({ memberId: memberTypeData.memberId })
      .then((res) => {
        setValues(res.data);
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setButtonDisable(true);
    values.lastContactFromOrganization = convertToDateString(
      lastContactWithMemberByUnit
    );
    values.lastInteractionWithOrganization = convertToDateString(
      lastMemberContactWithUnit
    );
    memberTypeData.memberTawajahTalabFormModel = values;
    addMember()
      .addMemberType(memberTypeData, false)
      .then((res) => {
        if (res.data === "CanNotChange") {
          swal({
            title: t("member__member_type_not_change_able"),
            icon: "warning",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else if (res.data === "Request Already Generated") {
          swal({
            title: t(res.data),
            icon: "error",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
        } else {
          swal({
            title: t(res.data),
            icon: "success",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            buttons: "OK",
          });
          history.goBack();
        }
        setLoading(false);
        setButtonDisable(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setButtonDisable(false);
      });
  };
  return (
    <Card className="mb-4">
      <CardHeader className="bg-white d-flex justify-content-between align-items-center py-3">
        <h4 className="mb-0" style={{ fontSize: "1.25rem", fontWeight: 500 }}>
          {applyClassToCharacters(
            getStringFromJSX(
              <GetLanguageString
                props="member_member_type_request_title"
                value={memberTypeData.memberType.label}
              />
            ),
            "ur"
          )}
        </h4>
        <Button
          color="default"
          className="d-flex align-items-center"
          onClick={() => history.goBack()}
        >
          <IoArrowBackSharp className="me-2" color="#18A689" size={15} />
          {<GetLanguageString props="courses_participants_back" />}
        </Button>
      </CardHeader>
      <CardBody>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            {" "}
            <Row>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",

                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"Tanzeem"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.tanzeemName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.tanzeemName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6">
                <Card
                  className="mb-3"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                    border: "none",
                  }}
                >
                  <CardBody>
                    <CardTitle
                      tag="h5"
                      style={{
                        color: colors.primary,
                        fontWeight: "600",
                        fontSize: "16px",
                        marginBottom: "12px",
                      }}
                    >
                      <GetLanguageString props={"member_report_member_halqa"} />
                    </CardTitle>
                    <CardText
                      className={isUrdu(values.halqaName) ? "ur" : ""}
                      style={{
                        fontSize: "18px",
                        color: colors.text,
                        fontWeight: "600",
                        wordBreak: "break-word",
                      }}
                    >
                      {values.halqaName || "—"}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <br></br>
            <Row>
              {[
                { key: "memberFullName", label: "common_name", isUrdu: true },
                {
                  key: "memberFatherName",
                  label: "member_father_name",
                  isUrdu: true,
                },
                {
                  key: "memberRegistrationNumber",
                  label: "member_report_member_registrationNumber",
                  isUrdu: true,
                },
                {
                  key: "tanzeemJoiningDate",
                  label: "member_joining_date",
                  isUrdu: true,
                },
              ].map((field) => (
                <Col md="3">
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          color: colors.text,
                          wordBreak: "break-word",
                        }}
                      >
                        {field.key.includes("date")
                          ? values[field.key]
                            ? moment(
                                convertUTCToLocalTime(values[field.key])
                              ).format("DD/MM/yyyy")
                            : ""
                          : values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <Row>
              {[
                {
                  key: "memberMobile",
                  label: "member_current_mobile_number",
                  isUrdu: false,
                },
                {
                  key: "memberCurrentAddress",
                  label: "member_rafiq_current_address",
                  isUrdu: true,
                },
                {
                  key: "tarufiEventDate",
                  label: "event_name_tarufi_ijtima",
                  isUrdu: false,
                },
                {
                  key: "mubtadiCourseDate",
                  label: "member_member_type_request_mubtadi_course_date",
                  isUrdu: false,
                },
                {
                  key: "mubtadiCourseLocation",
                  label: "member_member_type_request_mubtadi_course_location",
                  isUrdu: true,
                },
              ].map((field) => (
                <Col style={{ flex: 1 }}>
                  <Card
                    className="mb-3"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
                      height: "100%",
                      border: "none",
                    }}
                  >
                    <CardBody>
                      <CardTitle
                        tag="h5"
                        style={{
                          color: colors.primary,
                          fontWeight: "600",
                          fontSize: "16px",
                          marginBottom: "12px",
                        }}
                      >
                        <GetLanguageString props={field.label} />
                      </CardTitle>
                      <CardText
                        className={
                          field.isUrdu && isUrdu(values[field.key]) ? "ur" : ""
                        }
                        style={{
                          fontSize: "16px",
                          wordBreak: "break-word",
                          color: field.key.includes("Nisaab")
                            ? values[field.key]
                              ? "green"
                              : "red"
                            : colors.text,
                        }}
                      >
                        {field.key.includes("date")
                          ? values[field.key]
                            ? moment(
                                convertUTCToLocalTime(values[field.key])
                              ).format("DD/MM/yyyy")
                            : ""
                          : values[field.key] || "—"}
                      </CardText>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <br></br>
            <hr></hr>
            <br></br>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="form-label ur" style={{ fontSize: 15 }}>
                    کیا متعلقہ رفیق تنظیم میں شمولیت کے بعد ہی سے غیر فعال رہے
                    یا پھلے کسی دور میں وو فعال بھی تھے؟
                  </Label>
                  <Input
                    type="text"
                    name="wasActiveAfterJoining"
                    className={`form-control ${
                      isUrdu(values.wasActiveAfterJoining) ? "ur" : ""
                    }`}
                    value={values.wasActiveAfterJoining}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="form-label ur" style={{ fontSize: 15 }}>
                    رفیق کے مسلسل غیر فعال رہنے کی بنیادی وجہ کیا ہے؟
                  </Label>
                  <Input
                    type="text"
                    name="primaryInactivityReason"
                    className={`form-control ${
                      isUrdu(values.primaryInactivityReason) ? "ur" : ""
                    }`}
                    value={values.primaryInactivityReason}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label className="form-label ur" style={{ fontSize: 15 }}>
                    رفیق کی طرف سے نظم سے آخری بار رابطہ کب ہوا؟
                  </Label>
                  <DatePicker
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd/mm/yyyy"
                    maxDate={new Date()}
                    className="form-control"
                    selected={lastMemberContactWithUnit}
                    onChange={(date) => setLastMemberContactWithUnit(date)}
                    dateFormat="dd/MM/yyyy"
                  />
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label className="form-label ur" style={{ fontSize: 15 }}>
                    نظم نے رفیق سے آخری بار رابطہ کب کیا؟
                  </Label>
                  <DatePicker
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd/mm/yyyy"
                    maxDate={new Date()}
                    className="form-control"
                    selected={lastContactWithMemberByUnit}
                    onChange={(date) => setLastContactWithMemberByUnit(date)}
                    dateFormat="dd/MM/yyyy"
                  />
                </FormGroup>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col md="8"></Col>
              <Col md="4">
                <ButtonGroup className={GetCustomStyles().btn_group_style}>
                  <Button color="white" onClick={() => history.goBack()}>
                    {<GetLanguageString props="common_cancel" />}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    color="primary"
                    disabled={buttonDisable}
                    className="m-l-sm"
                    type="submit"
                  >
                    {<GetLanguageString props="common_save_changes" />}
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </CardBody>
    </Card>
  );
};

export default withRouter(MemberTypeRequestTawajahTalab);
